import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  withTheme
} from "@material-ui/core";
import * as React from "react";
import ContentCard from "../sharedComponents/ContentCard";
import s from "./forgotPasswordInitiate.module.css";
import { VisibilityOff, Visibility } from "@material-ui/icons";

import globalContext from "../../context/globalContext";

class PassLogin extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      token: props.match.params.token,
      error: false,
      labelText: "email",
      submitted: false,
      showPassword: false,
      helperText: "",
      errorText: ""
    };
  }

  handleChange = event => {
    let target = event.target;

    // if (!isEmail(target.value) && this.state.submitted) {
    //   this.setState({ error: true, labelText: "Must be a valid email" });
    // } else {
    //   this.setState({ error: false, labelText: "email" });
    // }

    this.setState({
      [target.name]: target.value,
      error: false,
      labelText: "email"
    });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !this.state.showPassword }));
  };

  render() {
    const {
      password,
      password_again,
      error,
      helperText
    } = this.state;
    const { errorSnackbarState } = this.context.global.data;

    if (errorSnackbarState) {
    }

    return (
      <ContentCard>
        <div className={s.container}>
          <h1 style={{ fontFamily: "'Montserrat', sans-serif" }}>
            New Password
          </h1>
          <p>Enter your new password.</p>
          <div className={s.middle}>
            <TextField
              name={"password"}
              placeholder={"password"}
              value={password}
              error={error}
              type={this.state.showPassword ? "text" : "password"}
              label={"password"}
              onChange={this.handleChange}
              autoCapitalize="none"
              autoCorrect="none"
              margin="normal"
              helperText={error ? helperText : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={{ position: "absolute", right: "0px", top: "16px" }}
                  >
                    <IconButton onClick={this.handleClickShowPassword}>
                      {this.state.showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              name={"password_again"}
              placeholder={"password again"}
              value={password_again}
              error={error}
              type={this.state.showPassword ? "text" : "password"}
              label={"password"}
              onChange={this.handleChange}
              autoCapitalize="none"
              autoCorrect="none"
              margin="normal"
              helperText={error ? helperText : ""}
            />
          </div>
          <div className={s.bottom}>
            <Button
              onClick={() => {
                if (password.length < 7) {
                  this.setState({
                    error: true,
                    errorText:
                      "Password length must be greater than 6 characters.",
                    submitted: true,

                    helperText:
                      "Password length must be greater than 6 characters."
                  });
                  return;
                }

                if (password === password_again) {
                  this.context.global
                    .submitPasswordForReset(password, this.state.token)
                    .then(res => {
                      this.props.history.replace(`/confirm-password-reset`);
                    })
                    .catch(err => {
                      this.setState({
                        error: true,
                        errorText: "Something went wrong.",
                        submitted: true
                      });
                    });
                } else {
                  this.setState({
                    error: true,
                    labelText: "Passwords must match",
                    helperText: "Passwords must match",
                    submitted: true
                  });
                }
              }}
            >
              Reset
            </Button>

            <div className={s.legalLine}>
              <p
                onClick={() => this.props.history.push("/privacy-policy")}
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                Privacy Policy
              </p>
              <p
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                |
              </p>
              <p
                onClick={() => this.props.history.push("/terms-of-service")}
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                Terms of Service
              </p>
            </div>
          </div>
        </div>
      </ContentCard>
    );
  }
}

export default withTheme()(PassLogin);
